import type { FC } from 'react';
import { useMemo } from 'react';

import { Stack } from '@polyai/ui/components/atoms/Stack';

import { NewFormRichTextInput } from 'components/molecules/Form/FormRichTextInput';
import { FormSelect } from 'components/molecules/Form/FormSelect';
import { FormTextInput } from 'components/molecules/Form/FormTextInput';
import { useIsFeatureOn } from 'hooks/useFeatureSwitch/useIsFeatureOn';
import useSmsCredentials from 'hooks/useSmsCredentials';
import type { FormProps } from '..';
import { SMS_TEMPLATES_MODAL } from '../SmsTemplatesModal.uiCopy';

type Props = {
  readonly?: boolean;
};
const SmsTemplateFormContent: FC<Props> = ({ readonly }) => {
  const { smsCredentials } = useSmsCredentials();
  const { isFeatureOn } = useIsFeatureOn();

  const numberOptions = useMemo(
    () =>
      smsCredentials?.numbers?.map(num => ({
        label: num,
        value: num,
      })),
    [smsCredentials],
  );
  return (
    <Stack direction="column" spacing="sm3">
      <FormTextInput<FormProps>
        controlKey="name"
        help={SMS_TEMPLATES_MODAL.form.title.helpText}
        label={SMS_TEMPLATES_MODAL.form.title.label}
        placeholder={SMS_TEMPLATES_MODAL.form.title.placeholder}
        readOnly={readonly}
      />
      <div className="[&_div[contenteditable]]:min-h-[100px]">
        <NewFormRichTextInput
          config={{
            variables: isFeatureOn('variables'),
            translations: isFeatureOn('multilingual_config'),
          }}
          controlKey="text"
          data-test-id="sms-body-text-area"
          help={SMS_TEMPLATES_MODAL.form.smsBody.helpText}
          label={SMS_TEMPLATES_MODAL.form.smsBody.label}
          placeholder={SMS_TEMPLATES_MODAL.form.smsBody.placeholder}
          readOnly={readonly}
        />
      </div>

      <FormSelect<FormProps>
        controlKey="envPhoneNumbers"
        data-test-id="envPhoneNumbers"
        help={SMS_TEMPLATES_MODAL.form.phoneNumber.helpText}
        label={SMS_TEMPLATES_MODAL.form.phoneNumber.label}
        options={numberOptions}
        readonly={readonly}
      />
    </Stack>
  );
};

export default SmsTemplateFormContent;
